import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SHARED_IMPORTS } from '../shared/shared-imports';
import { ContentService } from '../../services/content.service';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';


@Component({
	selector: 'user-invitation-create-component',
	standalone: true,
	templateUrl: 'components/user-invitation-create/user-invitation-create.component.html',
	imports: [
		...SHARED_IMPORTS,
		MatDialogModule,
		MatButtonModule,
		MatIconModule
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UserInvitationCreateComponent implements OnInit {
	UserInvitationCreateForm: any = {};
	roles: any[] = [];
	rolesFiltered: any[] = [];
	roleLowerThanManager: any;
	currentRole: any;
	users: any[] = [];
	languages: any[] = [];

	private http = inject(HttpClient);
	private content = inject(ContentService);
	private router = inject(Router);
	private dialog = inject(MatDialog);
	private snackBar = inject(MatSnackBar);

	constructor() { }

	ngOnInit(): void {
		this.getRoles();
		this.getLanguages();
	}

	goBack(): void {
		// Navigate back to UserList or Main using Angular Router
		this.router.navigate(['/UserList']);
	}

	getRoles(): void {
		this.http.get<any[]>('/api/user/Roles').subscribe((roles) => {
			this.roles = roles;
			this.rolesFiltered = [...roles];
			this.roleLowerThanManager = roles.find(r => r.RoleName === 'Manager');

			if (this.users && roles) {
				this.users.forEach(user => {
					user.role = roles.find(r => r.Id === user.GlobalAppRoleId);
				});
			}
		});
	}

	getLanguages(): void {
		this.http.get<any[]>('/api/user/Languages').subscribe((languages) => {
			this.languages = languages.map(lang => ({
				...lang,
				LanguageName: this.content.getContent('UserDetail.' + lang.LanguageName)
			}));
		});
	}

	inviteUser(): void {
		if (!this.UserInvitationCreateForm?.Email) {
			this.snackBar.open(
				this.content.getContent('Validation.InvalidEmail'),
				'OK',
				{ duration: 3000 }
			);
			return;
		}

		const spinner = document.getElementById('spinner');
		const submitBtn = document.getElementById('inviteSubmitButton');
		spinner?.classList.remove('hidden');
		submitBtn?.setAttribute('disabled', 'true');

		this.http.post('/api/user/Invite', this.UserInvitationCreateForm, {
			headers: { 'Content-Type': 'application/json' }
		}).subscribe({
			next: () => {
				const dialogRef = this.dialog.open(ConfirmDialogComponent, {
					data: {
						title: this.content.getContent("User.InvitationHasBeenSent"),
						text: this.content.getContent(
							"User.EmailWithInvitationCodeHasBeenSentTo",
							this.UserInvitationCreateForm.Email
						),
						okText: this.content.getContent("Standard.OK")
					}
				});
				dialogRef.afterClosed().subscribe(() => {
					this.UserInvitationCreateForm = {};
				});
			},
			error: (err) => {
				this.snackBar.open(
					this.content.getContent('Standard.SomethingWentWrong'),
					'OK',
					{ duration: 3000 }
				);
				console.error(err);
			},
			complete: () => {
				spinner?.classList.add('hidden');
				submitBtn?.removeAttribute('disabled');
			}
		});
	}
}
